import parseHTML from "../../lib/dom/funciones/parse_html";
const desplazadorDeLinea = (linea, direccion) => {
    const elemento = linea.querySelector('.linea_de_tiempo__linea__hito:nth-child(2)');
    return () => linea.scroll({
        left: linea.scrollLeft + direccion * elemento.offsetLeft,
        behavior: 'smooth'
    });
};
const lineaDeTiempo = () => {
    const hitos = Array.from(document.querySelectorAll('.linea_de_tiempo__hitos')), lineas = hitos.map(tabla => tabla.querySelector('ol'));
    if (hitos.length === 0) {
        return;
    }
    hitos.forEach((hito, i) => {
        const anterior = parseHTML('<button class="linea_de_tiempo__anterior" disabled>Anterior</button>'), siguiente = parseHTML('<button class="linea_de_tiempo__siguiente">Siguiente</button>'), navegacion = parseHTML('<div class="linea_de_tiempo__navegacion"></div>');
        navegacion.appendChild(anterior);
        navegacion.appendChild(siguiente);
        hito.appendChild(navegacion);
        anterior.addEventListener('click', desplazadorDeLinea(lineas[i], -1));
        siguiente.addEventListener('click', desplazadorDeLinea(lineas[i], 1));
        lineas[i].addEventListener('scroll', () => {
            anterior.disabled = lineas[i].scrollLeft === 0;
            siguiente.disabled = Math.abs(lineas[i].scrollLeft + lineas[i].clientWidth - lineas[i].scrollWidth) < 2;
        });
    });
    const ajustaScrolls = () => lineas.forEach((inner, i) => {
        if (inner.scrollWidth > inner.clientWidth) {
            hitos[i].classList.add('is-scrollable');
        }
        else {
            hitos[i].classList.remove('is-scrollable');
        }
    });
    const ajustaDistancia = (inner, i) => () => {
        hitos[i].style.setProperty('--distancia-izquierda', inner.scrollLeft + 'px');
        hitos[i].style.setProperty('--distancia-derecha', inner.scrollWidth - inner.clientWidth - inner.scrollLeft + 'px');
    };
    addEventListener('resize', ajustaScrolls);
    addEventListener('load', ajustaScrolls);
    ajustaScrolls();
    lineas.forEach((inner, i) => {
        const ajustador = ajustaDistancia(inner, i);
        inner.addEventListener('scroll', ajustador);
        addEventListener('resize', ajustador);
        addEventListener('load', ajustador);
    });
};
export default lineaDeTiempo;
